import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HeroBanner() {
  const featuredArticles = articles.filter((a) => a.isFeatured).slice(0, 3);

  return (
    <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20literary%20atmosphere%20with%20soft%20warm%20lighting%2C%20vintage%20books%20and%20delicate%20fabric%20textures%2C%20artistic%20composition%20with%20dreamy%20bokeh%2C%20warm%20amber%20and%20cream%20tones%2C%20sophisticated%20reading%20nook%20aesthetic%2C%20soft%20focus%20background&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="丝袜小说精选合集"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 text-center leading-tight">
          丝袜小说精选合集
        </h1>
        <p className="mt-4 md:mt-6 text-base md:text-lg text-background-100/90 text-center max-w-2xl leading-relaxed">
          汇聚海量精品原创故事，涵盖都市言情、青春校园、职场情感等多元题材，每日更新最新章节，为喜爱丝袜小说的读者提供极致阅读体验
        </p>

        <div className="flex items-center gap-3 mt-8 flex-wrap justify-center">
          <Link
            to="/category/dushi-yanqing"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-background-50/20 text-background-50 rounded-full font-medium text-sm border border-background-50/30 hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="hidden md:grid grid-cols-3 gap-4 mt-12 w-full max-w-3xl">
          {featuredArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50/10 backdrop-blur-sm rounded-lg p-4 border border-background-50/20 hover:bg-background-50/20 transition-all duration-300 cursor-pointer"
            >
              <span className="text-xs text-accent-300 font-medium">
                {index === 0 ? '🔥 今日推荐' : index === 1 ? '⭐ 编辑精选' : '💎 人气热门'}
              </span>
              <h3 className="text-sm font-semibold text-background-50 mt-2 line-clamp-2 group-hover:text-accent-300 transition-colors duration-200">
                {article.title}
              </h3>
              <p className="text-xs text-background-200 mt-1 line-clamp-2">{article.excerpt}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}